import { motion, useReducedMotion } from 'motion/react';

import Ticker from 'components/common/Ticker';
import BuildYourOwn from 'images/familyHome/family-social-build-your-own.jpg';
import FamilyEating from 'images/familyHome/family-social-family-eating.jpg';
import KidCooking from 'images/familyHome/family-social-kid-cooking.jpg';
import PretzelChicken from 'images/familyHome/family-social-pretzel-chicken.jpg';
import ShrimpRice from 'images/familyHome/family-social-shrimp-rice.jpg';
import TortelliniBake from 'images/familyHome/family-social-tortellini-bake.jpg';

const SocialTicker = ({ data }) => {
  const {
    title,
    buildYourOwnAlt,
    familyEatingAlt,
    KidCookingAlt,
    pretzelChickenAlt,
    shrimpRiceAlt,
    tortelliniBakeAlt,
    childrenCookingAlt,
    ingredientsOnCounterAlt,
  } = data;

  const socialTickerMedia = [
    {
      type: 'image',
      src: BuildYourOwn,
      alt: buildYourOwnAlt,
    },
    {
      type: 'video',
      src: 'https://asset.homechef.com/videos/family_home_page/social-ticker-video-3.mp4',
      alt: ingredientsOnCounterAlt,
    },
    {
      type: 'image',
      src: FamilyEating,
      alt: familyEatingAlt,
    },
    {
      type: 'image',
      src: KidCooking,
      alt: KidCookingAlt,
    },
    {
      type: 'image',
      src: PretzelChicken,
      alt: pretzelChickenAlt,
    },
    {
      type: 'video',
      src: 'https://asset.homechef.com/videos/family_home_page/social-ticker-video-4.mp4',
      alt: childrenCookingAlt,
    },
    {
      type: 'image',
      src: ShrimpRice,
      alt: shrimpRiceAlt,
    },
    {
      type: 'image',
      src: TortelliniBake,
      alt: tortelliniBakeAlt,
    },
  ];

  const prefersReducedMotion = useReducedMotion();

  return (
    <section className="bg-white-110 pb-10 pt-12">
      <motion.h2
        initial={{ opacity: 0, y: prefersReducedMotion ? 0 : 50 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.7, type: 'spring' }}
        viewport={{ once: true, amount: 0.5 }}
        className="h2 bp2:h1 mx-auto mb-6 max-w-2xl px-4 pb-8 text-center text-green-140 bp2:pb-12"
      >
        {title}
      </motion.h2>
      <motion.div
        initial={{ opacity: 0, y: prefersReducedMotion ? 0 : 50 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.7, type: 'spring' }}
        viewport={{ once: true, amount: 0.5 }}
        className="w-full"
      >
        <Ticker
          images={socialTickerMedia}
          containerClassName="mx-auto flex flex-row"
          imageWrapperClassName="px-2 bp2:px-3 aspect-[3/4] w-[240px] flex-shrink-0"
          imageClassName="rounded-lg"
        />
      </motion.div>
    </section>
  );
};

SocialTicker.propTypes = {
  data: PropTypes.shape({
    title: PropTypes.string,
    buildYourOwnAlt: PropTypes.string,
    familyEatingAlt: PropTypes.string,
    KidCookingAlt: PropTypes.string,
    pretzelChickenAlt: PropTypes.string,
    shrimpRiceAlt: PropTypes.string,
    tortelliniBakeAlt: PropTypes.string,
    childrenCookingAlt: PropTypes.string,
    ingredientsOnCounterAlt: PropTypes.string,
  }).isRequired,
};

export default SocialTicker;
